import { BrowserRouter, Routes, Route, HashRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./Redux";
import { AuthProvider } from "./contexts/AuthContext";
import ErrorBoundary from "./components/ErrorBoundary";
import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import HomePage from "./pages/HomePage";
import ScriptsPage from "./pages/ScriptsPage";
import ScriptDetailPage from "./pages/ScriptDetailPage";
import SignInPage from "./pages/SignInPage";
import SignUpPage from "./pages/SignUpPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import PlansPage from "./pages/PlansPage";
import CreditHistoryPage from "./pages/CreditHistoryPage";
import AccountSettingsPage from "./pages/AccountSettingsPage";
import NotFoundPage from "./pages/NotFoundPage";
import { ToastProvider } from "./components/Toast";

// Safe check for Tauri environment
let isTauriEnv = false;
try {
  const tauriCore = await import("@tauri-apps/api/core");
  isTauriEnv = tauriCore.isTauri();
} catch {
  isTauriEnv = false;
}

// Use HashRouter for Tauri (file:// protocol), BrowserRouter for web
const Router = isTauriEnv ? HashRouter : BrowserRouter;

function App() {
  return (
    <Provider store={store}>
      <Router>
        <AuthProvider>
          <ToastProvider>
          <ErrorBoundary>
          <Routes>
            {/* Public routes */}
            <Route path="/signin" element={<SignInPage />} />
            <Route path="/signup" element={<SignUpPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            
            {/* Protected routes */}
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Layout>
                    <HomePage />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/scripts"
              element={
                <ProtectedRoute>
                  <Layout>
                    <ScriptsPage />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/scripts/:id"
              element={
                <ProtectedRoute>
                  <Layout>
                    <ScriptDetailPage />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/plans"
              element={
                <ProtectedRoute>
                  <Layout>
                    <PlansPage />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/credits/history"
              element={
                <ProtectedRoute>
                  <Layout>
                    <CreditHistoryPage />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/account"
              element={
                <ProtectedRoute>
                  <Layout>
                    <AccountSettingsPage />
                  </Layout>
                </ProtectedRoute>
              }
            />
            {/* Catch-all 404 */}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
          </ErrorBoundary>
          </ToastProvider>
        </AuthProvider>
      </Router>
    </Provider>
  );
}

export default App;
